/* Browse bar: the filter drawer, the view-by toggle, and the grid density it
   controls.

   THE FILTER IS THE THEME'S OWN FORM, MOVED - NEVER RE-RENDERED
   snippets/global-filters.liquid renders a complete working unit: the sort
   select, every facet as its own <details>, the price slider, and a Clear and
   Apply pair, all wired to Shopify's facet AJAX. None of that is rebuilt here.
   What changes is only where it sits and what it looks like.

   On a standard collection or search page the theme already rendered one into
   .filterBlock, so it is moved into the drawer. On an editorial category page
   nothing rendered one, so the section renders it into the drawer in Liquid
   and this script leaves it alone.

   An earlier version rendered a second copy on every page and hid the first
   with CSS. That broke the price filter and said so in the console -
   "Identifier 'priceSlider' has already been declared" - because a hidden
   element still loads its scripts, and ranger.min.js declares its slider at
   the top level. One filter per page, always.

   THE GUARD, AND WHY IT EXISTS
   Which pages are editorial is a setting, and a setting can be wrong. It was:
   five templates were listed as editorial that do have a filter of their own,
   so those pages rendered two - two visible filter controls and that same
   console error. Liquid cannot catch this, because a section cannot see its
   siblings; by the time anything can look, both are already on the page.

   So the drawer checks for itself. If it was given a rendered copy and the
   page turns out to have its own filter as well, the copy is dropped and the
   page's own one is used - the setting is wrong but the shopper still gets one
   working filter rather than two broken ones. If this ever fires, the fix is
   to take that template out of the "Editorial templates" setting.

   WHY THE OBSERVER WATCHES #mainContent AND NOT THE WHOLE PAGE
   The facet AJAX replaces the form after every applied filter, which puts a
   fresh filter back on the page outside the drawer, so something has to notice.
   But the drawer itself is full of things that mutate on their own - the price
   slider writes its labels, the Apply button gets its count written into it -
   and an observer watching all of <body> would see its own edits and go round
   again. Watching the page's content, where the replacement actually happens,
   catches what matters and nothing it does itself.

   THE WRAPPER HAS TO BE DEFUSED, NOT JUST OPENED
   The theme's filter is a <details class="filter closex" data-close-outside>
   whose summary is the trigger. In the drawer the trigger is the FILTER button
   on the bar, so the wrapper is opened here and its summary hidden in CSS.

   Opening it is not enough on its own: data-close-outside tells the theme's own
   script to close the <details> whenever a click lands outside it, and the
   click that opens the drawer is itself outside it. So the attribute and the
   closex class are removed first. Without that, the theme closes what this
   opens, on every single click - and the two scripts take turns rewriting the
   same subtree until the tab stops responding.

   WHY THE DRAWER IS MOVED TO <body>
   Same reason the product panels are: the bar renders inside the header section
   group, and a z-index set inside a subtree that establishes its own stacking
   context ranks only against that subtree's children. Moved to <body> it ranks
   against the header, which is what a drawer covering the page needs to do.

   THE APPLY COUNT
   Shopify gives the filtered product count server-side, and the section prints
   it on the bar as a data attribute. This copies it into the Apply button, so
   the button reads APPLY (213) rather than just APPLY. It is the count for the
   filters currently in the URL, not a live preview of the boxes just ticked -
   that would need a request per tick. The theme's facet AJAX brings back an
   updated attribute, so it corrects itself as soon as a filter is applied.

   THE VIEW-BY TOGGLE
   The state is one attribute on <html> and all the column maths is CSS, with
   the numbers printed from the section's settings. The script never writes the
   label: all four numbers are in the markup and CSS picks which shows, so the
   label cannot disagree with the breakpoint in effect.

   The attribute is set inline in the section before the grids are parsed, so a
   shopper who chose more-per-row does not watch fewer-per-row repaint on every
   page load, and set again here in case that inline read was blocked - Safari
   in private mode throws on localStorage rather than returning null. */
(function () {
    'use strict';

    var KEY = 'dicoDensity';
    var ATTR = 'data-dico-density';
    var DEFAULT = 'compact';

    /* ---------------------------------------------------------- density */

    function readDensity() {
        try {
            var v = window.localStorage.getItem(KEY);
            return (v === 'compact' || v === 'expanded') ? v : DEFAULT;
        } catch (e) {
            return DEFAULT;
        }
    }

    function writeDensity(value) {
        try { window.localStorage.setItem(KEY, value); } catch (e) {}
    }

    function applyDensity(value) {
        document.documentElement.setAttribute(ATTR, value);
    }

    /* ------------------------------------------------------------ drawer */

    function panel() { return document.querySelector('[data-dico-bb-panel]'); }
    function overlay() { return document.querySelector('[data-dico-bb-overlay]'); }
    function drawerBody() { return document.querySelector('[data-dico-bb-body]'); }

    function hoistDrawer() {
        var p = panel();
        var o = overlay();
        if (p && p.parentNode !== document.body) { document.body.appendChild(p); }
        if (o && o.parentNode !== document.body) { document.body.appendChild(o); }
    }

    /* Open the wrapper for good: no close-outside handler, no close X, and
       marked so this runs once per filter rather than on every mutation. */
    function prepInner(body) {
        var wrapper = body.querySelector('details.filter');
        if (!wrapper || wrapper.hasAttribute('data-dico-prepped')) { return; }

        wrapper.setAttribute('data-dico-prepped', '');
        wrapper.removeAttribute('data-close-outside');
        wrapper.classList.remove('closex');
        wrapper.setAttribute('open', '');
    }

    /* Two filters on one page means the template is listed as editorial but is
       not. Drop the copy this section rendered and fall back to the page's own,
       so the shopper gets one working filter either way. */
    function resolveDuplicate(body) {
        if (body.getAttribute('data-dico-bb-body') !== 'rendered') { return; }

        var own = document.querySelector('.filterBlock details.filter');
        if (!own) { return; }

        var copy = body.querySelector('details.filter');
        if (copy) { copy.parentNode.removeChild(copy); }

        body.setAttribute('data-dico-bb-body', 'hoist');

        if (window.console && window.console.warn) {
            window.console.warn('dico browse bar: this template has its own filter - remove its suffix from the "Editorial templates" setting.');
        }
    }

    /* Move the page's own filter in, if the section did not render one. */
    function fillDrawer() {
        var body = drawerBody();
        if (!body) { return; }

        resolveDuplicate(body);

        if (body.getAttribute('data-dico-bb-body') === 'hoist' && !body.querySelector('details.filter')) {
            var source = document.querySelector('.filterBlock details.filter');
            if (source) {
                body.appendChild(source);
                var block = document.querySelector('.filterBlock');
                if (block) { block.setAttribute('hidden', ''); }
            }
        }

        prepInner(body);
    }

    function stampCount() {
        var bar = document.querySelector('[data-dico-bb-count]');
        if (!bar) { return; }

        var count = bar.getAttribute('data-dico-bb-count');
        if (!count) { return; }

        var applyBtn = document.querySelector('[data-dico-bb-body] button[type="submit"]');
        if (!applyBtn) { return; }

        if (applyBtn.getAttribute('data-dico-counted') === count) { return; }

        var label = applyBtn.getAttribute('data-dico-label');
        if (!label) {
            label = applyBtn.textContent.trim();
            applyBtn.setAttribute('data-dico-label', label);
        }

        applyBtn.textContent = label + ' (' + count + ')';
        applyBtn.setAttribute('data-dico-counted', count);
    }

    var lastFocus = null;

    function openDrawer() {
        var p = panel();
        var o = overlay();
        if (!p || !o) { return; }

        fillDrawer();

        lastFocus = document.activeElement;
        o.hidden = false;
        p.hidden = false;

        window.requestAnimationFrame(function () {
            o.classList.add('is-open');
            p.classList.add('is-open');
        });

        var close = p.querySelector('[data-dico-bb-close]');
        if (close) { close.focus(); }
    }

    function shutDrawer() {
        var p = panel();
        var o = overlay();
        if (!p || !o) { return; }

        o.classList.remove('is-open');
        p.classList.remove('is-open');

        window.setTimeout(function () {
            if (!p.classList.contains('is-open')) {
                o.hidden = true;
                p.hidden = true;
            }
        }, 300);

        if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
        lastFocus = null;
    }

    /* --------------------------------------------------------- listeners */

    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) { return; }

        if (t.closest('[data-dico-density-toggle]')) {
            e.preventDefault();
            var next = readDensity() === 'compact' ? 'expanded' : 'compact';
            writeDensity(next);
            applyDensity(next);
            return;
        }

        if (t.closest('[data-dico-bb-open]')) { e.preventDefault(); openDrawer(); return; }
        if (t.closest('[data-dico-bb-close]')) { e.preventDefault(); shutDrawer(); return; }
        if (t.closest('[data-dico-bb-overlay]')) { shutDrawer(); }
    });

    document.addEventListener('keydown', function (e) {
        var p = panel();
        if (!p || p.hidden) { return; }
        if (e.key === 'Escape' || e.keyCode === 27) { shutDrawer(); }
    });

    function start() {
        applyDensity(readDensity());
        hoistDrawer();
        fillDrawer();
        stampCount();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }

    /* The theme editor re-renders whole sections. */
    document.addEventListener('shopify:section:load', start);

    if (window.MutationObserver) {
        var watched = document.getElementById('mainContent') || document.body;
        var pending = null;

        new MutationObserver(function () {
            if (pending) { window.clearTimeout(pending); }
            pending = window.setTimeout(function () {
                pending = null;
                fillDrawer();
                stampCount();
            }, 60);
        }).observe(watched, { childList: true, subtree: true });
    }
}());